module.exports = __webpack_public_path__ + "static/img/sister.53787aa3.gif";